import { type OpenApiSchemaCommunication, type OpenApiSchemaCommunicationModal } from '#shared/api/schema';
import { matchesCommunication } from './matchesCommunication';

export type ModalCommunication = OpenApiSchemaCommunication & {
    alias: 'modal';
    details: { modal: OpenApiSchemaCommunicationModal };
};

export const selectModalCommunication = (
    communications: OpenApiSchemaCommunication[],
    pathname: string,
    searchParams: URLSearchParams,
    dismissedIds: ReadonlySet<string>
): ModalCommunication | undefined =>
    communications.find(
        (communication): communication is ModalCommunication =>
            communication.alias === 'modal' &&
            Boolean(communication.details.modal) &&
            matchesCommunication(communication, pathname, searchParams, dismissedIds)
    );
